import { showApolloErrorToast } from '@lingoda/toasts';
import { useStoriesData } from './useStoriesData';

export const useYearlyRecapVisible = ({ skip }: { skip?: boolean }) => {
    const { data, loading } = useStoriesData({
        onError: showApolloErrorToast,
        skip,
    });

    const isYearlyRecapVisible = !!data;

    return { isYearlyRecapVisible, loading };
};
